import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { take } from 'rxjs/operators';
import { GetPayLaterProgramService } from '../../../services/pay-later/get-pay-later-program.service';
@Injectable()
export class PayLaterGuard implements CanActivate {
    constructor(private _getPayLaterProgram: GetPayLaterProgramService) {}

    public async canActivate(): Promise<boolean> {
        const isPayLaterEnabled = await this._getPayLaterProgram.isPayLaterEnabled$
            .pipe(take(1))
            .toPromise();

        return isPayLaterEnabled;
    }
}
